import { HeaderView } from '@merchant-backend/common-components'
import { isUltimate } from '@merchant-backend/util'
import { observer, Provider } from 'mobx-react'
import React, { Component } from 'react'
import Detail from './Detail'
import Modal from './Modal'
import ProtocalModal from './Modal/protocolModal'
import Overview from './Overview'
import Store from './store'
import Title from './Title'
import Trend from './Trend'
@observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.store = new Store()
    const _isUltimate = isUltimate()
    _isUltimate && this.store.getOverview()
    _isUltimate && this.store.getTrend()
    !_isUltimate && this.store.getDetail()
  }

  render() {
    return (
      <Provider store={this.store}>
        <HeaderView title={<Title />}>
          <Overview />
          <Trend />
          <Detail />
          <Modal />
          <ProtocalModal />
        </HeaderView>
      </Provider>
    )
  }
}
